import { useEffect } from "react"
import { useReactOidc } from "@axa-fr/react-oidc-context"

const Logout = () => {
  const { login, logout } = useReactOidc()
  useEffect(() => {
    login()
    setTimeout(() => {
      logout()
    }, 500)
  }, [])
  return (
    <>
    </>
  )
}
export default Logout